import matchRoutePattern from '../../hooks/useUserViewContext/helpers/matchRoutePattern';
import type { MatchSubscriptionParams, MatchSubscriptionResult } from '../types';

const matchSubscription = ({
    subscription,
    pathname,
    event,
    routeParams,
}: MatchSubscriptionParams): MatchSubscriptionResult => {
    if (event.type !== subscription.eventType) {
        return {
            matched: false,
            matchParams: {},
        };
    }

    const routeMatchResult =
        subscription.routePattern === '*'
            ? {
                  matched: true,
                  params: {},
              }
            : matchRoutePattern({ pathname, pattern: subscription.routePattern });

    if (!routeMatchResult.matched) {
        return {
            matched: false,
            matchParams: {},
        };
    }

    if (subscription.filter) {
        const passesFilter = subscription.filter({
            event,
            matchParams: routeMatchResult.params,
            routeParams,
        });

        if (!passesFilter) {
            return {
                matched: false,
                matchParams: {},
            };
        }
    }

    return {
        matched: true,
        matchParams: routeMatchResult.params,
    };
};

export default matchSubscription;
